import { User } from "firebase/auth";
import Image from "next/image";
import { AccountNavigation } from "./AccountNavigation";

type NavUserDropdownProps = {
  user: User;
  handleLogout: () => void;
};

export const NavUserDropdown = ({
  user,
  handleLogout,
}: NavUserDropdownProps) => {
  return (
    <div className="absolute right-3 top-[70px] z-50 flex max-w-[328px] shrink-0 flex-col rounded-xl border border-solid border-tab-border bg-white shadow-lg medium:right-[22px]">
      <div className="flex items-center">
        <div className="mx-6 my-5">
          <Image
            src={user.photoURL || ""}
            alt="Profile Image"
            width={48}
            height={48}
            className="rounded-[80px]"
          />
        </div>
        <div className="flex flex-col">
          <p className="text-base font-[650] not-italic leading-[20px_] text-dark-color">
            {user.displayName}
          </p>
          <p className="text-base font-normal not-italic leading-[20px_] text-gray-text">
            {user.email}
          </p>
        </div>
      </div>
      <hr className="h-px w-[328px] border-tab-border" />
      <AccountNavigation handleLogout={handleLogout} location="drop_down" />
    </div>
  );
};
